module.exports = __webpack_public_path__ + "static/media/header-background.a6e90615.png";


//////////////////
// WEBPACK FOOTER
// ./src/view/scenes/Images/header-background.png
// module id = 88
// module chunks = 0